/**
 * heute-mock.ts — the Heute Dashboard placeholder data (Story UI-U3, AC 2).
 *
 * These blocks (decision KPIs, Umsatz series, KI-Empfehlungen, Aktivität feed)
 * have NO backend endpoint yet. They render in MOCK mode from here; in LIVE mode
 * the screen passes empty arrays so each block shows its design-conform empty
 * state instead of fabricated numbers (same honesty rule as the KundeDetail
 * mock-only tabs). Extracted out of DashboardScreen so live mode = empty arrays.
 */
import { RefreshCw, FileText, Mail, AlertTriangle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { StatusTone } from '../../components/ui/StatusDot';
import { KOMMUNIKATION_ENABLED } from '../../lib/feature-flags';

export interface HeuteDecision {
  tone: StatusTone;
  label: string;
  value: string;
  sub: string;
  icon: LucideIcon;
  /** Route the card navigates to on click. */
  to: string;
}

export const HEUTE_DECISIONS: HeuteDecision[] = [
  { tone: 'danger', label: 'Kritisch', value: "CHF 48'200", sub: 'Renewal · Genève Maritime', icon: RefreshCw, to: '/renewals' },
  { tone: 'warning', label: 'Hoch', value: "CHF 12'480", sub: 'Rechnung · AXA · K3', icon: FileText, to: '/rechnungen' },
  { tone: 'warning', label: 'Hoch', value: '26 Min', sub: 'Eingang · Alpina Pharma', icon: Mail, to: KOMMUNIKATION_ENABLED ? '/kommunikation' : '/posteingang' },
  { tone: 'warning', label: 'Hoch', value: 'Heute fällig', sub: 'Klärung · Schaden AXA', icon: AlertTriangle, to: '/rechnungen' },
];

export interface HeuteChartPoint {
  m: string;
  /** Umsatz / Prämienvolumen (chart-1). */
  v: number;
  /** Bestand / Policenanzahl (chart-2). */
  b: number;
}

export const HEUTE_CHART_SERIES: HeuteChartPoint[] = [
  { m: 'Apr', v: 538000, b: 184 }, { m: '', v: 545000, b: 186 }, { m: '', v: 552000, b: 189 }, { m: 'Mai', v: 560000, b: 191 },
  { m: '', v: 566000, b: 194 }, { m: '', v: 575000, b: 197 }, { m: '', v: 582000, b: 199 }, { m: 'Jun', v: 596000, b: 203 },
  { m: '', v: 604000, b: 206 }, { m: '', v: 612000, b: 209 },
];

export interface HeuteRecommendation {
  kind: string;
  tag: 'Chance' | 'Risiko';
  tone: 'success' | 'danger';
  konfidenz: number;
  text: string;
}

export const HEUTE_RECOMMENDATIONS: HeuteRecommendation[] = [
  {
    kind: 'Cross-Selling-Chance',
    tag: 'Chance',
    tone: 'success',
    konfidenz: 86,
    text: 'Basler Chemie AG hat keine Cyber-Deckung, aber ein erhöhtes Risikoprofil. Eine Cyber-Police passt zum Bestand.',
  },
  {
    kind: 'Renewal-Risiko',
    tag: 'Risiko',
    tone: 'danger',
    konfidenz: 73,
    text: 'Die Police von Genève Maritime SA läuft in 9 Tagen aus; der Versicherer signalisiert eine Prämienerhöhung.',
  },
];

export interface HeuteActivityItem {
  txt: string;
  ref: string;
  t: string;
}

export const HEUTE_ACTIVITY: HeuteActivityItem[] = [
  { txt: 'hat eine Rechnung (K1) automatisch freigegeben.', ref: 'RE-2026-04688', t: 'vor 4 Min.' },
  { txt: 'hat einen Schadensfall der Police POL-883-4471 zugeordnet.', ref: 'AXA · Schaden', t: 'vor 22 Min.' },
  { txt: 'hat eine neue Firma aus einem E-Mail-Eingang erstellt.', ref: 'Alpina Pharma AG', t: 'vor 1 Std.' },
];
